import React, { useState, useEffect } from 'react'
import { MultiCascader } from 'rsuite'

import { loadLocation } from '../../components/location/Location'

export default function TragetArea({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [location, setLocation] = useState()
  const [schema, setSchema] = useState(_schema)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleLocation()
  }, [])

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await loadLocation()
    setLocation(location)
    setIsLoading(false)
  }

  return (
    <div>
      {/* {addressInputForm()} */}

      <Controller
        name={schema.name}
        control={control}
        defaultValue={schema.value || []}
        //rules={isValidators(schema.validators)}
        render={(props) => {
          return (
            <MultiCascader
              size="lg"
              block
              menuWidth={200}
              data={location}
              value={props.value}
              onChange={(value) => {
                props.onChange(value)
              }}
              placeholder={schema.label}
              renderValue={(value, selectedItems) => {
                return <span>{selectedItems.map((item) => item.label).join(' , ')}</span>
              }}
            ></MultiCascader>
          )
        }}
      />
    </div>
  )
}
